import { h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { ResultItemContext } from '../../../types';
import { ServiceItemType } from '@cewe-onsitesearch/schemas';

const ServiceResultItemTemplate = (context: ResultItemContext) => (
  <result-item
    type={context.item.type}
    class={context.hidden ? 'hidden' : ''}
    href={context.item.links.page}
    key={context.key}
    onClick={() => context.ref.onSelectItem(context.item, context.position, context.queryID, context.listType)}
    tabindex="0"
  >
    {context.item.category !== '' ? (
      <result-item-label
        link={context.item.links.category}
        onClick={(event: MouseEvent) =>
          context.ref.onCategoryClick(event, context.item, context.position, context.listType)
        }
      >
        {context.item.category}
      </result-item-label>
    ) : (
      <result-item-label></result-item-label>
    )}
    <result-item-headline>{context.item.name}</result-item-headline>
    {context.item.type === ServiceItemType.FaqPage ? (
      <result-item-descr>{context.item.description}</result-item-descr>
    ) : (
      ''
    )}
  </result-item>
);

export default ServiceResultItemTemplate;
